import { render, staticRenderFns } from "./pl-popper.vue?vue&type=template&id=48cd1fc2&"
import script from "./pl-popper.vue?vue&type=script&lang=js&"
export * from "./pl-popper.vue?vue&type=script&lang=js&"
import style0 from "./pl-popper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports